import { render, staticRenderFns } from "./PostTemplate.vue?vue&type=template&id=0c96049c&scoped=true"
import script from "./PostTemplate.vue?vue&type=script&lang=js"
export * from "./PostTemplate.vue?vue&type=script&lang=js"
import style0 from "./PostTemplate.vue?vue&type=style&index=0&id=0c96049c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c96049c",
  null
  
)

export default component.exports